.trashcan {
	margin-top: -5px;
}
